import { AxiosResponse } from 'axios';
import { get } from 'lodash';
export type IResponseData<T = any> = AxiosResponse<{
  data: T,
  message: string;
}>;

export interface Pageable {
  sort: Sort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface Sort {
  sorted: boolean;
  empty: boolean;
  unsorted: boolean;
}

export const getMessageError = (error: any, fallbackString = 'Request failed') => get(error, ['response', 'data', 'message'], fallbackString) || fallbackString;